<template>
  <div class="info-user">
    <div class="setting-userinfo-user-container">
      <el-form :model="userInfoForm" ref="userInfoForm" label-width="100px" class="setting-userinfo-user-form">
        <el-form-item
            label="真实姓名"
            prop="realName"
        >
          <el-input type="text" v-model="userInfoForm.realName" autocomplete="off" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item
            label="工号"
            prop="no"
        >
<!--          :rules="[-->
<!--          { required: true, message: '工号不能为空'}-->
<!--          ]"-->
          <el-input type="text" v-model="userInfoForm.no" autocomplete="off"  placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item
            label="手机号"
            prop="tel">
          <el-input type="tel" disabled :value="userData.csMobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <span class="wl-btn" @click="submitUserForm('userInfoForm')">保存</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'info-user',
    data() {
      return {
        userInfoForm:{
          realName: '',
          no:'',
        },
      }
    },
    computed:{
      userData(){
        return this.$store.getters.user
      }
    },
    created(){
      this.getUserData()
    },
    mounted() {

    },
    methods: {
      getUserData(){
        this.$http.getProfileAPI().then( res => {
          if(res.status == 1){
            this.userInfoForm.realName = res.data.csRealname
            this.userInfoForm.no = res.data.csNo
          }
        })
      },
      /**
       * 保存修改的个人信息
       * @param formName
       */
      submitUserForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http.saveChangeProfileAPI(this.userInfoForm).then( res => {
              if(res.status == 1){
                this.$message({
                  message: res.msg,
                  type: 'success'
                })
                // this.userData.csName = this.userInfoForm.realName
                // let userInfo = this.userData
                // this.$store.dispatch('user/changeUserInfo',userInfo)
                this.getUserData()
              }else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style lang="scss">
.info-user{
  .setting-userinfo-user-container{
    .setting-userinfo-user-form{
      width: 500px;
    }
  }
}
</style>
